import "./About.css";

import React from "react";

export default function About() {
  return (
    <div className="about">
      <div className="container">
        <h4 className="about-title">
          <p> “From procurement to packaging, we’ve got it all covered.”</p>
          we carefully craft our process to deliver the desired quality for your
          brand at
          <p> maximum cost & time efficiency,</p>
          minimizing wastage and with utmost Accuracy.
        </h4>
        <a href="#" className="about-link">
          learn more about our processing
        </a>
      </div>
    </div>
  );
}
